module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_04@3x-e2e9a467e9d1379decd59aee00cabdea.webp";